import { render, staticRenderFns } from "./PriceOutdate.vue?vue&type=template&id=7fcb0316&"
import script from "./PriceOutdate.vue?vue&type=script&lang=js&"
export * from "./PriceOutdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7fcb0316', component.options)
    } else {
      api.reload('7fcb0316', component.options)
    }
    module.hot.accept("./PriceOutdate.vue?vue&type=template&id=7fcb0316&", function () {
      api.rerender('7fcb0316', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/PriceOutdate.vue"
export default component.exports